/* eslint-disable @typescript-eslint/naming-convention */

import { install } from 'ga-gtag';

export const GTM_SCRIPT_ATTR = 'data-gtm-script';

const gtmInitialize = (gtmId) => {
  if (!gtmId) return;

  const headScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');`;

  const noScriptBody = `<iframe src="https://www.googletagmanager.com/ns.html?id='${gtmId}'"
        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`;

  const headElement = document.head || document.querySelector('head');
  const bodyElement = document.body || document.querySelector('body');

  const existingGtmElement = headElement.querySelectorAll(`script[${GTM_SCRIPT_ATTR}]`);

  if (existingGtmElement.length && existingGtmElement[0].innerHTML.includes(gtmId)) return;

  const script = document.createElement('script');
  script.innerHTML = headScript;
  script.setAttribute(GTM_SCRIPT_ATTR, 'true');
  headElement.insertBefore(script, headElement.childNodes[0]);

  const noScript = document.createElement('noscript');
  noScript.innerHTML = noScriptBody;
  bodyElement.insertBefore(noScript, bodyElement.childNodes[0]);
};

const getSHA256Hash = async (input) => {
  try {
    const textAsBuffer = new TextEncoder().encode(input);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray.map((item) => item.toString(16).padStart(2, '0')).join('');
    return hash;
  } catch {
    return window.btoa(input);
  }
};

const sendGTMEvent = async (eventName: string, params: any = {}) => {
  window.dataLayer = window.dataLayer || [];
  const { user_id, ...otherParams } = params;
  const identifier = user_id ? { user_id: await getSHA256Hash(user_id) } : {};
  window.dataLayer.push({ event: eventName, ...otherParams, ...identifier });
};

const gtagInitilize = (gtmId: string) => {
  if (!gtmId) {
    return;
  }

  install(gtmId, { send_page_view: false });
};

export { gtmInitialize, gtagInitilize, sendGTMEvent };

const GoogleTagManager = {
  boot: gtmInitialize,
  bootGtag: gtagInitilize,
};

export default GoogleTagManager;
